import { render } from "./AbbreviationsView.vue?vue&type=template&id=0c35ef14&lang=pug"
import script from "./AbbreviationsView.vue?vue&type=script&lang=js"
export * from "./AbbreviationsView.vue?vue&type=script&lang=js"

import "./AbbreviationsView.vue?vue&type=style&index=0&id=0c35ef14&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__